import { render, staticRenderFns } from "./ShiftSelectWrapper.vue?vue&type=template&id=4480c822&scoped=true&"
import script from "./ShiftSelectWrapper.vue?vue&type=script&lang=js&"
export * from "./ShiftSelectWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSelectWrapper.vue?vue&type=style&index=0&id=4480c822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480c822",
  null
  
)

export default component.exports